import { createAction } from 'redux-actions'

import axios from '../services/Request'

export const requestCitiesFail = createAction('CITIES_FAIL_FETCH')
export const requestCities = createAction('CITIES_REQUEST_FETCH')
export const requestCitiesSuccess = createAction('CITIES_SUCCESS_FETCH')
export const setCitiesDataAction = createAction('SET_CITIES_DATA')

const dependencies = { axios }

export const setCitiesData = cities =>
  dispatch => {
    dispatch(setCitiesDataAction(cities))
  }

export const fetchCities = injection => {
  const { axios } = { ...dependencies, injection }

  return dispatch => {
    dispatch(requestCities())
    return axios().get('/city')
      .then(({ data }) => {
        const features = data.map(({ name, polygon }) => {
          const polygonObject = JSON.parse(polygon)

          return {
            type: 'Feature',
            properties: {
              name
            },
            geometry: polygonObject
          }
        })

        const citiesMapData = {
          features,
          type: 'FeatureCollection'
        }

        return dispatch(requestCitiesSuccess({ cities: citiesMapData }))
      })
      .catch(err =>
        dispatch(requestCitiesFail(new Error(err)))
      )
  }
}



// WEBPACK FOOTER //
// ./src/actions/cities.js